import * as React from 'react';
import { BuildingIcon, WorkspaceIcon } from '../icons';
import _sortBy from 'lodash/sortBy';
import _map from 'lodash/map';
import { Icon, Spin, Button } from '.';
import { Text, Divider, Header, settings, shadows, fontSizes, fontWeights } from '../../style';
import { FunctionGrid } from '../commons';
import { ModalOptions } from '../../providers';
import { ListTile } from './list';
/** Method for getting the modal display configuration for the choose location modal */
export function ProductLocationModal(availableProjects: IProject[], data: any, callback: Props['callback'], inEditor: boolean = true, close: any = null,): ModalOptions {
	return ({
		// title: "Välj plats",
		okText: "",
		cancelText: "",
		body: (<ProductLocationModalBody projects={availableProjects} data={data} callback={callback} close={close} inEditor={inEditor}/>),
		centered: true
	});
}
interface Props {
	/** Selectable projects to show */
	projects: IProject[]
	data: any
	/** Callback to close the modal, it will be called with the current state of the modal */
	callback: (result : State) => Promise<any>
	close?: () => Promise<any>
	inEditor: boolean
}
const CSS = {
	container: '',
	header: 'mr-2.5 ml-2.5 font-normal text-md text-start',
	button: 'w-full h-[3em] mb-[1em]',
	box: 'mr-[5%] mb-[10%] ml-[5%]',
	headerText: 'text-left ml-2.5 mt-[1em] font-semibold',
	column: 'flex flex-col justify-between content-stretch',
	row: 'flex flex-[0_1] flex-row text-sm items-center z-[100]',
	text: 'mr-2.5 ml-2.5 font-normal text-sm',
	icon: 'text-[2.7em]',
};
interface State {
	/** Indicates that the user has decided to either save or not save the product in the list of unsorted products */
	saveInUnsortedProducts: boolean | undefined
	/** Currently selected project in the modal */
	project?: IProject | undefined
	/** Currently selected building in the modal */
	building?: IBuilding | undefined
	other?: IOther | undefined
	/** Currently selected facade in the modal */
	facade?: IFacade | undefined
	/** Finally the selected floor choosen in the modal */
	floor?: IFloor | undefined
	loading: any
}

const ProductLocationModalBody: React.FC<Props> = (props) => {
	const [saveInUnsortedProducts, setSaveInUnsortedProducts] = React.useState<boolean | undefined>(undefined);
	const [project, setProject] = React.useState<IProject | undefined>(undefined);
	const [building, setBuilding] = React.useState<IBuilding | undefined>(undefined);
	const [other, setOther] = React.useState<IOther | undefined>(undefined);
	const [facade, setFacade] = React.useState<IFacade | undefined>(undefined);
	const [floor, setFloor] = React.useState<IFloor | undefined>(undefined);
	const [loading, setLoading] = React.useState<any>(false);

	// Helper to build a State object from current state values + overrides
	const buildState = (overrides: Partial<State> = {}): State => ({
		saveInUnsortedProducts,
		project,
		building,
		other,
		facade,
		floor,
		loading,
		...overrides,
	});

	const renderProjectSelection = () => {
		return (
			<>
				{/* <Text>Dessa projekt finns tillgängliga:</Text>
				<Divider />
				{!projects.length && <><Divider/><Text>Det finns inga projekt att välja</Text><Divider/></>}
				{map(projects, project =>
					<FunctionPill key={project.name} onClick={() => setState({ project })}>
						<Icon component={Icons.ProjektComponent} className="svg-icon" style={{ fontSize: em(2.7), justifySelf: 'flex-start' }} />
						<Text className={CSS.header}>{project.name}</Text>
					</FunctionPill>
				)}
				<Button className={CSS.button} onClick={() => setState({ saveInUnsortedProducts: undefined })}>Tillbaka</Button> */}
			</>
		)
	};

	const renderBuildingSelection = (proj: IProject) => {
		return (
			<>
			<Icon type="left" style={{ fontSize: fontSizes.lg,marginTop:'0em', float:'left', marginLeft: 0, position: "inherit" }} onClick={() => setProject(undefined)} />
			{/* <Text>{!proj.buildings.length ? `Det finns inga byggnader att välja i ${proj.name}` : `Välj en byggnad i ${proj.name}:`}</Text> */}
			<Header className={CSS.headerText} style={{textAlign:'center',fontSize: fontSizes.lg}}>Välj Hus</Header>
			{(!proj.buildings.length && !proj.others.length) ? null : <Header className={CSS.headerText} style={{marginBottom:8, fontSize: fontSizes.lg}} >Hus</Header>}
			<div style={{ overflow: 'hidden', overflowY: 'scroll', maxHeight: '120vw' }}>
			{loading ? <Spin size="large" /> :
			<>
			{_map(proj.buildings, bld =>
				<div style={{width: '50%', float:'left'}} key={bld.name}>
					<div className={CSS.box}>
						<FunctionGrid
							key={bld.name}
							style={{
								boxShadow: shadows.thick,
							}}
							onClick={() => { setBuilding(bld)}}>
							<div style={{
								minWidth: '80px',
								minHeight: '90px',
								backgroundImage: `url('/static/database/icons/project/house_black_shadow.svg')`,
								backgroundSize: '90px'
								}}
							/>
							<div style={{
								// width: px(80),
								overflow: 'hidden',
								textOverflow: 'none',
								textAlign: 'center',
								whiteSpace: 'nowrap',
							}}>
							<Text className={CSS.header}>{bld.name}</Text>
							</div>
						</FunctionGrid>
					</div>
				</div>
			)}
			{_map(proj.others, (oth, index) =>
			<div style={{width: '50%', float:'left'}} key={oth.name + " " + index}>
				<div className={CSS.box}>
					<FunctionGrid
						key={oth.name}
						onClick={() => {
							setOther(oth);
							setLoading(true);
							// Use setTimeout to ensure state is updated before callback
							setTimeout(() => {
								props.callback(buildState({ other: oth, loading: true }));
							}, 0);
						}}
						style={{
							boxShadow: shadows.thick,
						}}
					>
						<div style={{
							width: '60px',
							height: '60px',
							backgroundImage: `url('/static/database/icons/project/others.svg')`,
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat'
						  }}
						/>
						<div style={{
							// width: px(80),
							overflow: 'hidden',
							textOverflow: 'none',
							textAlign: 'center',
							whiteSpace: 'nowrap',
						}}>
						<Text className={CSS.header}>{oth.name}</Text>
						</div>
					</FunctionGrid>
				</div>
			</div>
			)}
			</>}
			</div>
			{(!proj.buildings.length && !proj.others.length) ?
				<div>
					<div style={{ marginTop: "20px", marginBottom: "24px", textAlign: "initial", marginLeft: "6px", fontSize: fontSizes.md }}>
						Inga hus hittades. Gå till <b>Projektet</b> för att lägg till hus, fasader, tak och våningar.
					</div>
					<Button type="primary" className={CSS.button} style={{ width: '60%' }} onClick={() => props.close && props.close()}>Okej</Button>
				</div>
			: null}
			{/* <Button className={CSS.button} onClick={() => setSaveInUnsortedProducts(undefined)}>Tillbaka</Button> */}
			</>
		);
	};


	const renderFacadeOrRoofSelection = (bld: IBuilding) => {
		const roofsObject = bld.roofs;
		const fasadeObject = bld.facades;
		const facades = [...fasadeObject, ...roofsObject];
		return (
			<>
			<Icon type="left" style={{ fontSize: fontSizes.lg,marginTop:'0em', float:'left', marginLeft:0, position: "inherit" }} onClick={() => setBuilding(undefined)} />
			<Header className={CSS.headerText} style={{textAlign:'center',fontSize: fontSizes.lg}}>Välj fasad</Header>
			{(!facades.length) ? null : <Header className={CSS.headerText} style={{marginBottom:8, fontSize: fontSizes.lg}} >Fasader</Header>}
			<div style={{ overflow: 'hidden', overflowY: 'scroll', maxHeight: '120vw' }}>
			{loading ? <Spin size="large" /> : _map(facades, (fcd: any) =>
				<React.Fragment  key={fcd.name}>
					{/* @ts-ignore */}
					<div style={{width: '50%', float:'left'}} >
						<div className={CSS.box}>
						<FunctionGrid
							key={fcd.name}
							// @ts-ignore
							onClick={() => {
								if (fcd) {
									if (fcd.isRoof) {
										setFloor(fcd);
										setLoading(true);
										setTimeout(() => {
											props.callback(buildState({ floor: fcd, loading: true }));
										}, 0);
									} else {
										setFacade(fcd);
									}
								}
							}}
							style={{
								boxShadow: shadows.thick
							}}
						>
							<div style={{
								minWidth: '80px',
								minHeight: '100px',
								backgroundImage: `url('/static/database/icons/project/${fcd && fcd.isRoof ? 'roof_black_shadow.svg' : 'facade_black_shadow.svg'}')`,
								backgroundSize: '90px',
								backgroundPosition: 'center',
								backgroundRepeat: 'no-repeat'
							}}
							/>
							<div style={{
								// width: px(80),
								overflow: 'hidden',
								textOverflow: 'none',
								textAlign: 'center',
								whiteSpace: 'nowrap',
							}}>
							<Text className={CSS.header}>{fcd.name}</Text>
							</div>
						</FunctionGrid>
						</div>
					</div>
				</React.Fragment>
			)}
			</div>
			{(!facades.length) ?
				<div>
					<div style={{ marginTop: "20px", marginBottom: "24px", textAlign: "initial", marginLeft: "6px", fontSize: fontSizes.md }}>
						Inga fasader hittades. Gå till <b>Projektet</b> för att lägg till hus, fasader, tak och våningar.
					</div>
					<Button type="primary" className={CSS.button} style={{ width: '60%' }} onClick={() => props.close && props.close()}>Okej</Button>
				</div>
			: null}
			</>
		);
	};

	const renderFloorSelection = (fcd: IFacade, bld: IBuilding) => {
		return (
			<>
			{/* <Text>{fcd.floors.length ? `Välj ett våning för ${bld.name}, ${fcd.name}:` : `Det finns inget golv att välja på ${fcd.name}`}</Text> */}
			{/* <Divider/> */}
			<Icon type="left" style={{ fontSize: fontSizes.lg,marginTop:'0em', float:'left', marginLeft:0, position: "inherit" }} onClick={() => setFacade(undefined)} />
			<Header className={CSS.headerText} style={{textAlign:'center',fontSize: fontSizes.lg}}>Välj våning</Header>
			{(!fcd || !fcd.floors || !fcd.floors.length) ? null: <Header className={CSS.headerText} style={{marginBottom:8, fontSize: fontSizes.lg}} >Våningar</Header>}
			<div style={{ maxHeight: '120vw', overflow: 'scroll', margin: '0 -15px', padding: '0 15px' }}>
			{_map(fcd.floors, flr =>
				<ListTile
					style={{ padding:5, boxShadow: shadows.light }}
					key={flr.name}
					onClick={() => {
						setFloor(flr);
						setLoading(true);
						setTimeout(() => {
							props.callback(buildState({ floor: flr, loading: true }));
						}, 0);
					}}
					right={
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', height: '100%', width: '30px' }}>
							{loading && floor && floor.name === flr.name ?
								<Spin size="small"/>
							:
								<Icon type="right" style={{ fontSize: fontSizes.lg }} />
							}
						</div>
					}
					title={
						<Text style={{fontWeight: fontWeights.medium, fontSize: fontSizes.md, marginLeft:10, padding: 10}}>{flr.name}</Text>
					}
				/>
			)}
			</div>
			{(!fcd || !fcd.floors ||!fcd.floors.length) ?
				<div>
					<div style={{ marginTop: "20px", marginBottom: "24px", textAlign: "initial", marginLeft: "6px", fontSize: fontSizes.md }}>
						Inga våningar hittades. Gå till <b>Projektet</b> för att lägg till hus, fasader, tak och våningar.
					</div>
					<Button type="primary" className={CSS.button} style={{ width: '60%' }} onClick={() => props.close && props.close()}>Okej</Button>
				</div>
			: null}
			{/* <Button className={CSS.button} onClick={() => setFacade(undefined)}>Tillbaka</Button> */}
			</>
		);
	};

	/** renders the correct list to choose from according to the current state */
	const renderOptions = () => {
		const { translate } = props.data;
		const noProjects = !props.projects.length;
		const sortedProjects = _sortBy(props.projects.filter((proj) => !proj.isArchive), proj => proj.updatedAt);
		if (!facade && !building && !project) {
			return (<>
				{/* {!sortedProjects.length && <><Divider/><Text>Det finns inga projekt att välja</Text><Divider/></>} */}
				<Header className={CSS.headerText} style={{textAlign:'center',fontSize: fontSizes.lg }}>Välj plats för produkten</Header>
				{props.data.currentUserTypeAccess.projects &&
				<>
				<Header className={CSS.headerText} style={{marginTop:15, fontSize: fontSizes.lg}} >Mina projekt</Header>
				<div style={{ marginLeft: "-10px", paddingLeft: "10px", marginRight: "-10px", paddingRight: "10px", marginBottom: '12px', paddingBottom: '20px' }}>
					{_map(sortedProjects, (proj, index) =>
						<ListTile
							key={proj.name + " " + index}
							onClick={() => { setSaveInUnsortedProducts(false); setProject(proj); }}
							style={{
								boxShadow: shadows.thick,
								height: '70px',
								boxSizing: 'border-box'
							}}
							left={
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', height: '100%', width: '50px' }}>
									<Icon component={BuildingIcon} className="svg-icon" style={{ fontSize: 'var(--icon-3xl)' }} />
								</div>
							}
							right={
								<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', height: '100%', width: '30px' }}>
									<Icon type="right" style={{ fontSize: fontSizes.lg }} />
								</div>
							}
							hiddenWidth={settings.hiddenIconWidth}
							title={
								<div style={{ display: "flex", alignItems: "center", height: '100%', width: '100%' }}>
									<div className={CSS.column} style={{ marginTop: '0px', width: '100%' }}>
										<Text className={CSS.header}>{proj.name}</Text>
										{/* {getProjectBadges(item)} */}
									</div>
								</div>

							}
						/>
					)}
				</div>
				{noProjects && <><Text>Du har inga projekt att välja</Text><Divider /></>}
				</>
				}<Header style={{marginTop:15, fontSize: fontSizes.lg}} className={CSS.headerText}>{translate("projects:cart:header")}</Header>
				<ListTile
					onClick={() => {
						setSaveInUnsortedProducts(true);
						setLoading(true);
						setTimeout(() => {
							props.callback(buildState({ saveInUnsortedProducts: true, loading: true }));
						}, 0);
					}}
					style={{
						boxShadow: shadows.thick,
						height: '70px',
						boxSizing: 'border-box'
					}}
					left={
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', height: '100%', width: '50px' }}>
							<Icon component={WorkspaceIcon} className="svg-icon" style={{ fontSize: 'var(--icon-3xl)' }} />
						</div>
					}
					right={
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'row', height: '100%', width: '30px' }}>
						{loading ?
							<Spin size="small"/>
						:
							<Icon type="right" style={{ fontSize: fontSizes.lg }} />
						}
					</div>
					}
					hiddenWidth={settings.hiddenIconWidth}
					title={
						<div style={{ display: "flex", alignItems: "center", height: '100%', width: '100%' }}>
							<div className={CSS.column} style={{ marginTop: '0px', width: '100%' }}>
								<Text className={CSS.header}>{translate("projects:cart:Verkstaden")}</Text>
							</div>
						</div>
					}
				/>
				{/* {props.inEditor && <Button type="default" className={CSS.button} onClick={() => props.callback(buildState())} >Fortsätt redigera</Button>} */}
			</>)
		}
		else if (facade) {
			return renderFloorSelection(facade, building!);
		}
		else if (building) {
			return renderFacadeOrRoofSelection(building);
		}
		else if (project) {
			return renderBuildingSelection(project);
		}
		// else if (saveInUnsortedProducts == true) {
		// 	return <Spin size="large"/>
		// }
		return renderProjectSelection();
	};

	return (
		<div className={saveInUnsortedProducts == undefined ? "" : CSS.container} style={{ textAlign: 'center' }}>
			{renderOptions()}
		</div>
	);
};
